import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import {
  Outlet,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import Footer from "./Footer";
import Popup3 from "../components/Popup3";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useIndexPageData } from "../contextapi/Indexpagedata";
import { updatelogin } from "../redux/authSlice";

const WebLayout = () => {
  const { token, userType, isLoggedIn, userid } = useSelector(
    (state) => state.auth
  );
  const getCurrentURLParameters = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const params = {};
    for (const [key, value] of searchParams) {
      params[key] = value;
    }
    return params;
  };

  const { status } = getCurrentURLParameters();

  const [showRemove, setShowRemove] = useState(status ? true : false);
  const modalCloseRemove = () => setShowRemove(false);

  return (
    <div className="main-wrapper">
      <ModalFormRemove
        showRemove={showRemove}
        modalCloseRemove={modalCloseRemove}
        status={status}
        userType={userType}
      />
      <Navbar />
      <div className="main-content" style={{ paddingTop: "60px" }}>
        <div>
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default WebLayout;
const ModalFormRemove = ({
  showRemove,
  modalCloseRemove,
  userType,
  status,
}) => {
  const { profiledata, fetchDataprofile, setprofiledata } = useIndexPageData();
  const [Loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleButtonClick = () => {
    const params = new URLSearchParams(window.location.search);
    // if (params.has('status')) {
    //   params.delete('status');
    //   navigate({ search: params.toString() }, { replace: true });
    // }
    modalCloseRemove();
  };

  const handlenavigate = () => {
    navigate("/user/dashboard");
  };

  useEffect(() => {
    if (profiledata?.role) {
      dispatch(updatelogin({ userType: profiledata?.role }));
    }
  }, [profiledata?.role]);

  return (
    <Modal
      show={showRemove}
      onHide={() => {
        modalCloseRemove();
        handleButtonClick();
      }}
      dialogClassName="alert-modal"
      centered
    >
      <Modal.Body
        style={{
          padding: "40px 30px",
          background: "#F8D4B7",
          borderTopRightRadius: "24px",
          borderBottomLeftRadius: "24px",
        }}
      >
        <section className="text-center">
          <p>
            {status === "cancel" ? (
              <>
                Payment Cancelled <br />
                Your payment was not completed.
              </>
            ) : (
              <>
                Payment Successful <br />
                You can use your mockup in the User Dashboard.
              </>
            )}
          </p>
          {status !== "cancel" && (
            <div>
              <button
                className="btn grey-btn mb-3 px-5"
                style={{
                  width: "190px",
                  paddingTop: "8px",
                  paddingBottom: "8px",
                }}
                onClick={handlenavigate}
              >
                Go to dashboard
              </button>
            </div>
          )}
        </section>
      </Modal.Body>
    </Modal>
  );
};
